export default __webpack_public_path__ + "static/media/porshe.455f5fdb.jpg";